/* global axios */
import ApiClient from './ApiClient';

// Biblioteca de mídia da conta (fotos enviadas e geradas por IA).
class MediaAssetsAPI extends ApiClient {
  constructor() {
    super('media_assets', { accountScoped: true });
  }

  get({ kind } = {}) {
    return axios.get(this.url, { params: kind ? { kind } : {} });
  }

  upload(file, altText = '', kind = 'upload') {
    const data = new FormData();
    data.append('file', file);
    if (altText) data.append('alt_text', altText);
    data.append('kind', kind);
    return axios.post(this.url, data);
  }

  update(id, attrs) {
    return axios.patch(`${this.url}/${id}`, { media_asset: attrs });
  }

  usage(id) {
    return axios.get(`${this.url}/${id}/usage`);
  }
}

export default new MediaAssetsAPI();
